import { motion } from "framer-motion";
import { Check } from "lucide-react";

const highlights = [
  "25+ years senior commercial experience",
  "Work directly with a senior partner — every time",
  "National service — working with clients right across Australia",
];

export const About = () => (
  <section id="about" data-testid="about-section" className="bg-[#F2EDE6] py-24 sm:py-32">
    <div className="mx-auto max-w-4xl px-4 text-center sm:px-8">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
      >
        <p className="overline-tag mb-5" style={{ color: "#B01E28" }}>The Partner</p>
        <h2 className="font-heading text-2xl font-semibold tracking-tight text-[#1C1512] sm:text-3xl lg:text-4xl">
          Direct partner <span className="font-display italic text-ruby">accountability</span>
        </h2>
        <p
          className="mx-auto mt-10 max-w-3xl font-display text-2xl italic leading-relaxed text-[#2A221D] sm:text-3xl"
          data-testid="about-quote"
        >
          &ldquo;Over 25 years in sales and marketing. You work directly with the person who does
          the work: one partner, one plan, measurable commercial growth.&rdquo;
        </p>
      </motion.div>

      <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-3">
        {highlights.map((h, i) => (
          <motion.div
            key={h}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
            data-testid={`about-highlight-${i}`}
            className="flex items-center gap-4 rounded-2xl border border-[#1C1512]/10 bg-white/70 p-6 text-left"
          >
            <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-ruby/30 bg-ruby/10">
              <Check className="h-4 w-4 text-ruby" />
            </span>
            <span className="text-sm leading-snug text-[#3E362F]">{h}</span>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
